import { twMerge } from "tailwind-merge";
import { Typography } from "@pondigitalsolutions/pon-component-library";

const STATUS_VARIANTS = {
  success:
    "bg-accent_two-500 border-accent_two-500 dark:bg-transparent [&>svg]:stroke-white [&>svg]:dark:stroke-accent_two-300",
  error:
    "bg-accent_three-700 border-accent_three-700 dark:bg-transparent [&>svg]:stroke-white [&>svg]:dark:stroke-accent_three-100",
  warning:
    "bg-accent_one-600 border-accent_one-600 dark:bg-transparent [&>svg]:stroke-white [&>svg]:dark:stroke-accent_one-100",
  info: "bg-primary-500 border-primary-500 dark:bg-transparent [&>svg]:stroke-secondary-700 [&>svg]:dark:stroke-accent_secondary-100",
  default:
    "bg-white border-tertiary-50  dark:bg-white/10 dark:border-white/20 [&>svg]:stroke-secondary-700 [&>svg]:dark:stroke-white",
};

const STATUS_VARIANTS_TEXT = {
  success: "text-accent_two-50 dark:text-accent_two-300",
  error: "text-accent_one-50 text-accent_three-50 dark:text-accent_three-100",
  warning: "text-accent_one-50 dark:text-accent_one-100",
  info: "dark:text-secondary-100",
  default: "text-secondary-800 dark:text-white",
};

interface PillProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: keyof typeof STATUS_VARIANTS;
  className?: string;
  id?: string;
  type?: "button" | "submit" | "reset";
  "aria-haspopup"?: React.AriaAttributes["aria-haspopup"];
  "aria-expanded"?: boolean | "true" | "false";
  "aria-controls"?: string;
  "aria-label"?: string;
}

export const Pill = ({
  variant = "default",
  icon,
  onClick,
  children,
  className = "",
  id,
  type = "button",
  "aria-haspopup": ariaHaspopup,
  "aria-expanded": ariaExpanded,
  "aria-controls": ariaControls,
  "aria-label": ariaLabel,
}: PillProps) => {
  const pillClasses = twMerge(
    "flex items-center justify-center rounded-full border px-3 py-2 [&>svg]:w-3.5 [&>svg]:h-3.5 gap-1",
    STATUS_VARIANTS[variant],
    className
  );
  const textClasses = twMerge(
    "text-center leading-none font-normal",
    STATUS_VARIANTS_TEXT[variant]
  );

  if (onClick) {
    return (
      <button
        onClick={(e) => onClick(e)}
        className={pillClasses}
        id={id}
        type={type}
        aria-haspopup={ariaHaspopup}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-label={ariaLabel}
      >
        <Typography size="xs" className={textClasses}>
          {children}
        </Typography>
        {icon}
      </button>
    );
  }

  return (
    <div className={pillClasses}>
      <Typography size="xs" className={textClasses}>
        {children}
      </Typography>
      {icon}
    </div>
  );
};
